import { createSlice } from '@reduxjs/toolkit';

export const name = 'gameFacet';
const initialState: GameFacetState = {
	faceted: false,
	id: null,
	title: null,
	sport: null,
	league: null,
	startTime: null,
	endTime: null,
	status: null,
	hasAirings: false,
	page: 0,
	count: 0,
	autoRefetch: true,
	sorting: {
		orderBy: -1,
		orderDirection: ''
	}
};

export const gameFacetSlice = createSlice({
	name,
	initialState,
	reducers: {
		setIdFacet: (state, { payload }): void => {
			state.id = payload;
			state.page = initialState.page;
			state.count = initialState.count;
			state.faceted = true;
		},
		setTitleFacet: (state, { payload }): void => {
			state.title = payload;
			state.page = initialState.page;
			state.count = initialState.count;
			state.faceted = true;
		},
		setSportFacet: (state, { payload }): void => {
			state.sport = payload;
			state.page = initialState.page;
			state.count = initialState.count;
			state.faceted = true;
		},
		setLeagueFacet: (state, { payload }): void => {
			state.league = payload;
			state.page = initialState.page;
			state.count = initialState.count;
			state.faceted = true;
		},
		setStartTimeFacet: (state, { payload }): void => {
			state.startTime = payload;
			state.page = initialState.page;
			state.count = initialState.count;
			state.faceted = true;
		},
		setEndTimeFacet: (state, { payload }): void => {
			state.endTime = payload;
			state.page = initialState.page;
			state.count = initialState.count;
			state.faceted = true;
		},
		setStatusFacet: (state, { payload }): void => {
			state.status = payload;
			state.page = initialState.page;
			state.count = initialState.count;
			state.faceted = true;
		},
		toggleHasAiringsFacet: (state): void => {
			state.hasAirings = !state.hasAirings;
			state.page = initialState.page;
			state.count = initialState.count;
			state.faceted = true;
		},
		setPage: (state, { payload }): void => {
			state.page = payload;
		},
		setCount: (state, { payload }): void => {
			state.count = payload;
		},
		toggleAutoRefetch: (state): void => {
			state.autoRefetch = !state.autoRefetch;
		},
		setSorting: (state, { payload }): void => {
			state.sorting = payload;
		},
		resetAllFacets: (state): void => {
			state.id = initialState.id;
			state.title = initialState.title;
			state.sport = initialState.sport;
			state.league = initialState.league;
			state.startTime = initialState.startTime;
			state.endTime = initialState.endTime;
			state.status = initialState.status;
			state.hasAirings = initialState.hasAirings;
			state.page = initialState.page;
			state.count = initialState.count;
			state.autoRefetch = initialState.autoRefetch;
			state.sorting = initialState.sorting;
			state.faceted = false;
		}
	}
});

export const {
	setIdFacet,
	setTitleFacet,
	setSportFacet,
	setLeagueFacet,
	setStartTimeFacet,
	setEndTimeFacet,
	setStatusFacet,
	toggleHasAiringsFacet,
	setPage,
	setCount,
	resetAllFacets,
	toggleAutoRefetch,
	setSorting
} = gameFacetSlice.actions;

export default gameFacetSlice.reducer;

export interface GameFacetState {
	faceted: boolean;
	id: string | null;
	title: string | null;
	sport: string | null;
	league: string | null;
	startTime: string | null;
	endTime: string | null;
	status: string | null;
	hasAirings: boolean;
	page: number;
	count: number;
	autoRefetch: boolean;
	sorting: {
		orderBy: number;
		orderDirection: string;
	};
}
